<template lang="pug">
v-text-field(
    v-bind="$attrs"
    v-on="$listeners"
    :rules="projectRules"
    label='Project Name'
    data-track="project-name"
    dense clearable outlined required)

</template>

<script lang="ts">
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputProjectName extends Vue {
  projectRules = [(v: string) => isConvertibleToNotBlankString(v) || 'Project Name is required'];
}
</script>
